import { Injectable, Pipe, PipeTransform } from '@angular/core'
import { Meeting, Speaker, SpeakerMapping } from './meetings.service'

export function formatSpeaker(speaker: Speaker, speakerMapping: SpeakerMapping) {
  return speaker.name ?? speakerMapping![speaker.speakerTag] ?? speaker.speakerTag ?? ''
}

@Pipe({
  name: 'speaker',
  standalone: true,
})
@Injectable()
export class SpeakerPipe implements PipeTransform {
  transform(speaker: Speaker, speakerMapping: SpeakerMapping): string {
    return formatSpeaker(speaker, speakerMapping)
  }
}
